__turbopack_context__.v({
  "container": "o6K53a_container",
  "contentSkeleton": "o6K53a_contentSkeleton",
  "contentWrapper": "o6K53a_contentWrapper",
  "defaultContentWrapper": "o6K53a_defaultContentWrapper",
  "defaultImageSkeleton": "o6K53a_defaultImageSkeleton",
  "imageSkeleton": "o6K53a_imageSkeleton",
  "previewContentWrapper": "o6K53a_previewContentWrapper",
  "previewImageSkeleton": "o6K53a_previewImageSkeleton",
  "row": "o6K53a_row",
  "skeletonShimmer": "o6K53a_skeletonShimmer",
});
